<template>
  <div class="menu-dropdown" ref="wrapper">
    <button
      type="button"
      class="dropdown-button btn mr-0 btn-white"
      :disabled="disabled"
      @click.prevent="toggle"
    >
      <span class="dropdown-span container-button" style="font-size: 14px !important;">
        {{ menu.name }}
      </span>
    </button>

    <ul tabindex="-1" class="menu-dropdown-ul" :class="isOpen ? 'show' : ''">
      <li
        class="dropdown-li"
        role="presentation"
        :key="i"
        v-for="(item, i) in menu.children"
        @click="item.onClick"
      >
        <a class="nav-link dropdown-a">
          {{ item.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NavbarSubMenuDropDown',
  props: {
    menu: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isOpen: false,
  }),
  methods: {
    close() {
      this.isOpen = false;
    },
    open() {
      this.isOpen = true;
    },
    toggle() {
      this.isOpen = !this.isOpen;
    },
    /** handle outside clicks */
    onMouseDown(event) {
      if (!event || !event.target) return;

      const isDropdownChildren = this.$refs.wrapper.contains(event.target);

      if (isDropdownChildren || !this.isOpen) return;

      this.close();
    },
  },
  mounted() {
    document.addEventListener('mousedown', this.onMouseDown);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onMouseDown);
  },
};
</script>

<style lang="scss" scoped>
.menu-dropdown-ul {
  display: none;
  position: absolute;
  list-style: none;

  background: #f9f9f9 !important;
  border: 1px solid #c8ced5 !important;
  border-radius: 0px 0px 8px 8px;

  &.show {
    display: block;
    z-index: 5;
  }

  li {
    cursor: pointer;

    a {
      color: #7b8088 !important;
    }
  }
}
</style>
